import DenunciationList from '@/components/denunciation/DenunciationList'
import DenunciationCreate from '@/components/denunciation/DenunciationCreate'

export default [
  {
    path: '/denonciations',
    name: 'DenunciationList',
    component: DenunciationList,
    meta: {
      parentName: 'Home',
      requiresAuth: true
    }
  },
  {
    path: '/denonciations/creation',
    name: 'DenunciationCreate',
    component: DenunciationCreate,
    meta: {
      parentName: 'DenunciationList',
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/denunciationRouter.js